/*
 * Hairline divider on warm/card surfaces.
 */
import { styled } from '@mui/material/styles';

const GpDivider = styled('hr', {
  shouldForwardProp: (prop) => prop !== 'spacing',
})(({ spacing = 16 }) => ({
  border: 0,
  borderTop: '1px solid var(--gp-hairline)',
  margin: `${spacing}px 0`,
  height: 0,
}));

export default GpDivider;
